module.exports = __webpack_public_path__ + "img/mobile-11.bbceb62f.png";